import { DallasTableDataCell } from '@ui/Dallas/Table/DallasTable';
import DallasStack from '@ui/Dallas/Stack/DallasStack';
import DallasDivider from '@ui/Dallas/Dividers/DallasDivider';
import DallasTextSkeleton from '@ui/Dallas/Text/DallasTextSkeleton';

import styles from '../LoadTableCells/EquipmentCompactCell.module.scss';

interface Props {
  className?: string;
}

export default function EquipmentCompactSkeletonCell({ className }: Props) {
  return (
    <DallasTableDataCell className={className}>
      <DallasStack
        className={styles.stack}
        direction="row"
        gap="xs"
        alignVertical="center"
      >
        <div className={styles.trailerTypes}>
          <DallasTextSkeleton variant="captionL" fullLine />
        </div>
        <DallasDivider orientation="vertical" />
        <div className={styles.dimensions}>
          <DallasTextSkeleton variant="captionL" fullLine />
          <DallasTextSkeleton variant="captionL" partialLine />
        </div>
      </DallasStack>
    </DallasTableDataCell>
  );
}
